var Backbone, SupportHelpWizardController, SupportSelectDifferentOrderMenuTemplate, SupportV2OrderListView, SupportV2SelectDifferentOrderMenuView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportV2OrderListView = require('./v2_order_list_view.coffee');

SupportSelectDifferentOrderMenuTemplate = require('../../../select_different_order_menu.html.mustache');

Backbone = require('backbone');

Backbone.$ = $;

SupportHelpWizardController = require('../../helpWizardController');

SupportV2SelectDifferentOrderMenuView = (function(superClass) {
  extend(SupportV2SelectDifferentOrderMenuView, superClass);

  function SupportV2SelectDifferentOrderMenuView() {
    return SupportV2SelectDifferentOrderMenuView.__super__.constructor.apply(this, arguments);
  }

  SupportV2SelectDifferentOrderMenuView.prototype.className = 'row select-order-menu';

  SupportV2SelectDifferentOrderMenuView.prototype.events = {
    "click #purchasedDateSortOrders": "sortAndRender",
    "click #merchantNameSortOrders": "sortAndRender",
    "click #chooseOrder": "chooseDifferentOrder"
  };

  SupportV2SelectDifferentOrderMenuView.prototype.initialize = function() {
    this.setSortParams();
    this.template = SupportSelectDifferentOrderMenuTemplate;
    return this.orderListView = new SupportV2OrderListView({
      currentOrdersFilter: this.currentOrdersFilter
    });
  };

  SupportV2SelectDifferentOrderMenuView.prototype.setSortParams = function() {
    this.currentOrdersFilter = Groupon.Support.currentOrdersFilter;
    this.sortParams = {
      sort_attribute: this.currentOrdersFilter.getSortAttribute(),
      sort_order: this.currentOrdersFilter.getSortOrder()
    };
    if (this.sortParams.sort_attribute === 'purchased_at') {
      this.currentSortElementId = 'purchasedDateSortOrders';
    } else {
      this.currentSortElementId = 'merchantNameSortOrders';
    }
    if (this.sortParams.sort_order === 'descending') {
      return this.isDescSortOrder = true;
    } else {
      return this.isDescSortOrder = false;
    }
  };

  SupportV2SelectDifferentOrderMenuView.prototype.resetSortParams = function() {
    if (this.isDescSortOrder) {
      this.sortParams.sort_order = 'descending';
    } else {
      this.sortParams.sort_order = 'ascending';
    }
    if (this.currentSortElementId === 'purchasedDateSortOrders') {
      return this.sortParams.sort_attribute = 'purchased_at';
    } else {
      return this.sortParams.sort_attribute = 'merchant_name';
    }
  };

  SupportV2SelectDifferentOrderMenuView.prototype.renderOrderListing = function() {
    this.$el.html(toHtml(this.template, this.toListingHash(), this.I18nScope));
    this.renderOrders();
    return this.delegateEvents();
  };

  SupportV2SelectDifferentOrderMenuView.prototype.renderDetails = function() {
    this.$el.html(toHtml(this.template, this.toDetailHash(), this.I18nScope));
    return this.delegateEvents();
  };

  SupportV2SelectDifferentOrderMenuView.prototype.renderOrders = function() {
    this.orderListView.removeView();
    this.orderListView.currentOrdersFilter = this.currentOrdersFilter;
    this.orderListView.render();
    return this.$el.find('.order-listing').html(this.orderListView.el);
  };

  SupportV2SelectDifferentOrderMenuView.prototype.toListingHash = function() {
    return {
      enableMerchantNameSortOrders: this.currentSortElementId === 'purchasedDateSortOrders',
      isV2: true,
      isOrderListing: true
    };
  };

  SupportV2SelectDifferentOrderMenuView.prototype.toDetailHash = function() {
    return {
      isV2: true,
      isOrderdetails: true
    };
  };

  SupportV2SelectDifferentOrderMenuView.prototype.toSignInHash = function() {
    return {
      isV2: true,
      showSignIn: true
    };
  };

  SupportV2SelectDifferentOrderMenuView.prototype.setCurrentFilter = function() {
    var filter;
    this.resetSortParams();
    filter = Groupon.Support.OrdersCollection.getFilterInstance(this.sortParams);
    filter.iterator.resetIterator();
    this.currentOrdersFilter = Groupon.Support.currentOrdersFilter = filter;
    return filter;
  };

  SupportV2SelectDifferentOrderMenuView.prototype.sortAndRender = function(e) {
    var currentjQuerySel;
    currentjQuerySel = $(e.currentTarget);
    if (this.currentSortElementId === currentjQuerySel.attr('id')) {
      this.isDescSortOrder = !this.isDescSortOrder;
    } else {
      this.removeDisableClassFromPreviousSortLink();
      this.currentSortElementId = currentjQuerySel.attr('id');
      this.addDisableClassToSortLink(this.currentSortElementId);
      this.setDefaultSortOrder();
    }
    this.setCurrentFilter();
    return this.renderOrders();
  };

  SupportV2SelectDifferentOrderMenuView.prototype.setDefaultSortOrder = function() {
    if (this.currentSortElementId === 'purchasedDateSortOrders') {
      return this.isDescSortOrder = true;
    } else {
      return this.isDescSortOrder = false;
    }
  };

  SupportV2SelectDifferentOrderMenuView.prototype.removeDisableClassFromPreviousSortLink = function() {
    var ele;
    ele = $('#' + this.currentSortElementId);
    return ele.removeClass("disabledLink");
  };

  SupportV2SelectDifferentOrderMenuView.prototype.addDisableClassToSortLink = function(selectorId) {
    var ele;
    ele = $('#' + selectorId);
    return ele.addClass("disabledLink");
  };

  SupportV2SelectDifferentOrderMenuView.prototype.chooseDifferentOrder = function() {
    SupportHelpWizardController.changeCurrentOrder(null);
    return SupportHelpWizardController.initOrdersFetch();
  };

  return SupportV2SelectDifferentOrderMenuView;

})(Backbone.View);

module.exports = SupportV2SelectDifferentOrderMenuView;

//# sourceMappingURL=data:application/json;base64,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
